"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ViewSquareAlternate: ['view-square-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.449,10.857h0l-.3-.319c-1.325-1.421-3.545-3.8-7.024-3.8-3.35,0-5.4,2.27-6.62,3.627-.161.178-.312.345-.453.494a2,2,0,0,0,0,2.758c.141.148.291.315.452.493,1.223,1.357,3.27,3.628,6.62,3.628,3.479,0,5.7-2.381,7.025-3.8l.3-.318A2,2,0,0,0,19.449,10.857Zm-7.325,4.879c-2.708,0-4.282-2.063-5.464-3.33a.25.25,0,0,1,0-.341c1.21-1.3,2.778-3.329,5.465-3.329,2.5,0,4.13,1.642,5.715,3.328a.248.248,0,0,1,0,.342C16.274,14.073,14.65,15.736,12.124,15.736Z', 'M9.624 12.236 A2.500 2.500 0 1 0 14.624 12.236 A2.500 2.500 0 1 0 9.624 12.236 Z', 'M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm0,21.75a.251.251,0,0,1-.25.25H2.25A.249.249,0,0,1,2,21.75V2.25A.249.249,0,0,1,2.25,2h19.5a.25.25,0,0,1,.25.25Z']],
  ViewCircleAlternate: ['view-circle-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z', 'M20.764,11.545C20.638,11.3,17.61,5.5,12,5.5S3.36,11.3,3.234,11.545a1,1,0,0,0,0,.91C3.36,12.7,6.389,18.5,12,18.5s8.639-5.8,8.765-6.045A.994.994,0,0,0,20.764,11.545ZM12,16.5c-3.574,0-5.952-3.273-6.718-4.5C6.047,10.773,8.425,7.5,12,7.5s5.953,3.273,6.719,4.5C17.952,13.227,15.574,16.5,12,16.5Z', 'M9.499 12.000 A2.500 2.500 0 1 0 14.499 12.000 A2.500 2.500 0 1 0 9.499 12.000 Z']],
  ViewOff: ['view-off', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.2,10.549a20.954,20.954,0,0,0-4.3-3.6l4-3.995a1,1,0,1,0-1.414-1.414l-.018.018a.737.737,0,0,1-.173.291l-19.5,19.5c-.008.007-.018.009-.026.017a1,1,0,0,0,1.631,1.088l4.146-4.146a11.26,11.26,0,0,0,4.31.939h.3c4.256,0,8.489-2.984,11.051-5.8A2.171,2.171,0,0,0,23.2,10.549ZM16.313,13.27a4.581,4.581,0,0,1-3,3.028,4.3,4.3,0,0,1-3.1-.19.253.253,0,0,1-.068-.407l5.56-5.559a.252.252,0,0,1,.407.067A4.3,4.3,0,0,1,16.313,13.27Z', 'M7.615,13.4a.244.244,0,0,0,.061-.24A4.315,4.315,0,0,1,7.5,12,4.5,4.5,0,0,1,12,7.5a4.276,4.276,0,0,1,1.16.173.244.244,0,0,0,.24-.062l1.941-1.942a.254.254,0,0,0-.1-.421A10.413,10.413,0,0,0,12,4.75C7.7,4.692,3.4,7.7.813,10.549a2.15,2.15,0,0,0-.007,2.9,21.209,21.209,0,0,0,3.438,3.03.256.256,0,0,0,.326-.029Z']],
  ViewCircle: ['view-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,17c-5.279,0-8.178-4.542-8.3-4.735a.5.5,0,0,1,0-.53C3.822,11.542,6.721,7,12,7s8.178,4.542,8.3,4.735a.5.5,0,0,1,0,.53C20.178,12.458,17.279,17,12,17Z', 'M16,12a4,4,0,1,0-4,4A4,4,0,0,0,16,12Zm-4,1.5A1.5,1.5,0,1,1,13.5,12,1.5,1.5,0,0,1,12,13.5Z']],
  View1: ['view-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.432,10.524C20.787,7.614,16.4,4.538,12,4.6,7.6,4.537,3.213,7.615.568,10.524a2.211,2.211,0,0,0,0,2.948C3.182,16.351,7.507,19.4,11.839,19.4h.308c4.347,0,8.671-3.049,11.288-5.929A2.21,2.21,0,0,0,23.432,10.524ZM7.4,12A4.6,4.6,0,1,1,12,16.6,4.6,4.6,0,0,1,7.4,12Z', 'M10.000 12.000 A2.000 2.000 0 1 0 14.000 12.000 A2.000 2.000 0 1 0 10.000 12.000 Z']],
  ViewCircle1: ['view-circle-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.049,7.094a1,1,0,0,0,1.373-.342A10.052,10.052,0,0,1,8.585,2.494,1,1,0,0,0,7.9.614,12.056,12.056,0,0,0,1.707,5.722,1,1,0,0,0,2.049,7.094Z', 'M23.872,10.141a1,1,0,1,0-1.978.291A10.2,10.2,0,0,1,22,11.9a10.023,10.023,0,0,1-2.236,6.3,1,1,0,0,0,1.552,1.261,12.017,12.017,0,0,0,2.556-9.319Z', 'M15.37,21.314a10.1,10.1,0,0,1-6.691.016,1,1,0,1,0-.664,1.887,12.057,12.057,0,0,0,8.029-.02,1,1,0,0,0-.674-1.883Z', 'M13.956,2.086A10.025,10.025,0,0,1,19.7,5.514a1,1,0,1,0,1.539-1.276A12.025,12.025,0,0,0,14.345.124a1,1,0,0,0-.389,1.962Z', 'M2,11.947a1.011,1.011,0,0,0-1-.995,1,1,0,0,0-.995,1,12.018,12.018,0,0,0,2.723,7.551,1,1,0,0,0,1.545-1.269A10.012,10.012,0,0,1,2,11.947Z', 'M19.449,10.857h0l-.3-.319c-1.325-1.421-3.544-3.8-7.024-3.8-3.35,0-5.4,2.27-6.62,3.627-.161.178-.312.345-.453.494a2,2,0,0,0,0,2.758c.141.148.291.315.452.493,1.224,1.357,3.27,3.628,6.62,3.628,3.48,0,5.7-2.381,7.025-3.8l.3-.318A2,2,0,0,0,19.449,10.857Zm-7.325,4.879c-2.707,0-4.282-2.063-5.464-3.33a.25.25,0,0,1,0-.341c1.21-1.3,2.779-3.329,5.465-3.329,2.5,0,4.13,1.642,5.715,3.328a.248.248,0,0,1,0,.342C16.274,14.073,14.651,15.736,12.124,15.736Z', 'M9.624 12.236 A2.500 2.500 0 1 0 14.624 12.236 A2.500 2.500 0 1 0 9.624 12.236 Z']],
  ViewSquare: ['view-square', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM19.448,13.615l-.3.318c-1.326,1.423-3.546,3.8-7.026,3.8-3.349,0-5.4-2.271-6.62-3.628-.161-.178-.31-.345-.452-.493a2,2,0,0,1,0-2.758c.142-.148.292-.315.453-.494,1.224-1.357,3.271-3.627,6.62-3.627,3.48,0,5.7,2.38,7.025,3.8l.3.32h0A2,2,0,0,1,19.448,13.615Z', 'M12.25,8.236a4,4,0,1,0,4,4A4.005,4.005,0,0,0,12.25,8.236Zm0,5.5a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12.25,13.736Z']],
  View: ['view', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.092,9.665C20.463,6.77,16.594,4.2,12.584,4.012,12.389,4,12.2,4,12,4,7.747,4.034,3.876,6.47,1.058,9.5c-.05.054-.1.109-.15.164a3.457,3.457,0,0,0,0,4.669C2.113,15.662,6.471,20,11.872,20h.256c5.4,0,9.759-4.338,10.966-5.667A3.456,3.456,0,0,0,23.092,9.665Zm-1.478,3.322c-2.17,2.388-5.32,4.655-8.642,4.968A8.317,8.317,0,0,1,12,18c-3.63-.085-6.84-2.11-9.286-4.658q-.167-.174-.329-.353a1.476,1.476,0,0,1,0-1.978C4.752,8.4,8.332,5.915,12,6a9.407,9.407,0,0,1,3.747.774,15.249,15.249,0,0,1,3.4,1.977,18.091,18.091,0,0,1,2.47,2.257A1.476,1.476,0,0,1,21.614,12.987Z', 'M12,8a3.9,3.9,0,0,0-.392.02.249.249,0,0,0-.183.385A1.994,1.994,0,0,1,8.5,11.049a.25.25,0,0,0-.4.137A3.584,3.584,0,0,0,8,12a4,4,0,1,0,4-4Z']],
  Binocular: ['binocular', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.309,13.817l-2.6-6.488a.52.52,0,0,0-.11-.168L18.18,5.737l-1.462-3.9a.517.517,0,0,0-.114-.178,2.881,2.881,0,0,0-3.708,0,.5.5,0,0,0-.146.354V7c-.325-.03-.656-.051-1-.051-.17,0-.335.008-.5.016V2.015a.5.5,0,0,0-.146-.354,2.881,2.881,0,0,0-3.708,0,.517.517,0,0,0-.114.178L5.82,5.737,4.4,7.161a.52.52,0,0,0-.11.168L1.691,13.817a5.5,5.5,0,1,0,9.559,3.7V11.977c.155-.015.319-.025.5-.025a5.017,5.017,0,0,1,1,.094v5.469a5.5,5.5,0,1,0,9.559-3.7ZM9.25,17.515a3.5,3.5,0,1,1-3.5-3.5A3.5,3.5,0,0,1,9.25,17.515Zm9,3.5a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,18.25,21.015Z']]
};
exports["default"] = _default;